import { render, staticRenderFns } from "./SelectByNpsChangeForm.vue?vue&type=template&id=b4573d84&scoped=true"
import script from "./SelectByNpsChangeForm.vue?vue&type=script&lang=ts"
export * from "./SelectByNpsChangeForm.vue?vue&type=script&lang=ts"
import style0 from "./SelectByNpsChangeForm.vue?vue&type=style&index=0&id=b4573d84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4573d84",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/search.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2FSelectByNpsChangeForm.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports